enum DefaultPaymentCodes {
  USD = 'USD',
  USD_NUMBER = 840,
  US = 'US',
}

export const DEFAULT_PAYMENT_CURRENCY = DefaultPaymentCodes.USD;
export const DEFAULT_PAYMENT_CURRENCY_NUMBER = DefaultPaymentCodes.USD_NUMBER;
export const DEFAULT_PAYMENT_COUNTRY = DefaultPaymentCodes.US;
